<template>
  <div class="row">
    <div class="col-1">
      <h5 style="margin-top: 5px;">{{ index+1 }}</h5>
    </div>
    <div class="col-3">
      <div class="form-group has-label">
        <el-select
          v-model="groupId"
          @change="changeGroup"
          :placeholder="$t('app.modules.product_family.addEdit.headers.group_properties')"
          size="large select-info">

          <el-option
            v-for="group in groups"
            :key="group.idGrupoPropiedad"
            :label="group.nombreGrupo"
            :value="group.idGrupoPropiedad">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="col-3">
      <div class="form-group has-label">
        <el-select
          :key="propiedad.idPropiedadFamiliaProducto"
          v-model="propiedad.propiedadFamilia_idPropiedadFamiliaProducto"
          @change="changeProperty"
          :placeholder="$t('app.modules.product_family.addEdit.headers.group_properties')"
          size="large select-info">

          <el-option
            v-for="p in propiedades"
            :key="p.idPropiedadFamiliaProducto"
            :label="p.nombrePropiedad"
            :value="p.idPropiedadFamiliaProducto">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="col-4">
      <div v-if="tipoPropiedad === 'image'">
        <el-upload
          class="upload-demo"
          action="#"
          accept="image/*"
          :file-list="fileList"
          :limit="1"
          :on-preview="handlePreview"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :auto-upload="false"
        >
          <n-button style="margin: 0"
            slot="trigger"
            size="small"
            type="primary"
          >{{ $t("app.upload.select_image") }}</n-button
          >
          <div class="el-upload__tip" slot="tip">
            {{ $t("app.upload.image_size_limit") }}
          </div>
        </el-upload>
      </div>
      <div v-else-if="tipoPropiedad === 'text'">
        <fg-input
          :key="index"
          type="text"
          placeholder="valor"
          v-model="propiedad.valorPropiedad"
        >
        </fg-input>
      </div>
      <div v-if="tipoPropiedad === 'file'">
        <el-upload
          class="upload-demo"
          action="#"
          accept="application/pdf"
          :file-list="fileList"
          :limit="1"
          :on-preview="handlePreview"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :auto-upload="false"
        >
          <n-button style="margin: 0"
            slot="trigger"
            size="small"
            type="primary"
          >{{ $t("app.upload.select_ffile") }}</n-button
          >
          <div class="el-upload__tip" slot="tip">
            {{ $t("app.upload.pdf") }}
          </div>
        </el-upload>
      </div>

    </div>
    <div class="col-1" style="text-align: center">
      <n-button
        style="margin: 0"
        class="like"
        type="danger"
        size="md"
        round
        icon
        @click.native="removeItem"
      >
        <i class="fa fa-trash" style="font-size: 20px"></i>
      </n-button>
    </div>
  </div>
</template>

<script>
import Propiedad from "@/models/familiaProducto/FamiliaProductoPropiedad";

export default {
  props: {
    groups: undefined,
    propiedad: {
      type: undefined,
      default: () => new Propiedad()
    },
    action: "create",
    index: 0
  },
  computed: {
    propiedades(){
      var group = this.groups.find(g => g.idGrupoPropiedad === this.groupId);
      return !!group ? group.propiedades : [];
    },
    tipoPropiedad(){
      var prop = this.propiedades.find(p => p.idPropiedadFamiliaProducto === this.propiedad.propiedadFamilia_idPropiedadFamiliaProducto);
      if(!!prop) return prop.tipo;
      return null;
    }
  },
  updated() {
  },
  mounted() {
    if(!!this.propiedad.grupoPropiedadFamiliaProducto_idGrupoPropiedad){
      this.groupId = this.propiedad.grupoPropiedadFamiliaProducto_idGrupoPropiedad;
      if(this.tipoPropiedad === "image"){
        this.fileList = [{
          uid: this.propiedad.valorPropiedad ,
          name: this.$t('app.modules.product_family.addEdit.headers.image'),
          url: this.propiedad.valorPropiedad
        }];
      }
      else if(this.tipoPropiedad === "file"){
        this.fileList = [{
          uid: this.propiedad.valorPropiedad ,
          name: this.$t('app.modules.product_family.addEdit.headers.file'),
          url: this.propiedad.valorPropiedad
        }];
      }

    }
    else if(this.groups.length > 0){
      this.groupId = this.groups[0].idGrupoPropiedad;
      this.propiedad.propiedadFamilia_idPropiedadFamiliaProducto = !!this.groups[0].propiedades ? this.groups[0].propiedades[0].idPropiedadFamiliaProducto : 0;
    }
  },
  created() {
  },
  data() {
    return {
      groupId: 0,
      fileList: []
    }
  },
  methods: {
    removeItem(){
      this.$emit('removeProperty', this.index);
    },
    changeGroup()
    {
      var group = this.groups.find(g => g.idGrupoPropiedad === this.groupId);
      if(!!group){
        this.propiedad.propiedadFamilia_idPropiedadFamiliaProducto = group.propiedades[0].idPropiedadFamiliaProducto;
      }
    },
    changeProperty(){
      this.propiedad.valorPropiedad = "";
    },
    handleRemove(){ this.propiedad.valorPropiedad = undefined; },
    handleChange(file){ this.propiedad.valorPropiedad = file.raw; },
    handlePreview(file){ window.open(file.url, "_blank"); }
  }
}
</script>

<style scoped>

</style>
